export function omit<T extends object, K extends ReadonlyArray<keyof T>>(
  obj: T,
  keys: K,
) {
  const ret = {} as {
    [K in keyof typeof obj]: (typeof obj)[K];
  };
  let key: keyof typeof obj;
  for (key in obj) {
    if (!keys.includes(key)) {
      ret[key] = obj[key];
    }
  }
  return ret;
}
